import { DayPlan } from "../../types/DayPlan";
import DB_PATH from "../DB_PATH";
import firebase from "../firebase";

export const updateDayPlan = async ({ dayPlan }: { dayPlan: DayPlan }) => {
  try {
    const firestore = firebase.firestore();
    await firestore
      .collection(DB_PATH.PLAN_DAY)
      .doc(dayPlan.id)
      .set(dayPlan, { merge: true }); // Using merge to update only provided fields
  } catch (error) {
    console.error("Error updating day plan:", error);
  }
};
